import Calendar from './Calendar.wrapper';
import { IEvent, eventTemplates } from './components';
import { ICalendar } from './Calendar.interfaces';
import { reducer, actions, selectors } from './store';

export default Calendar;
export { Calendar, IEvent, ICalendar, eventTemplates, reducer, actions, selectors };
